import React from 'react'
import PropTypes from 'prop-types'
import ProductFinder from '../../functional/product-finder/ProductFinder'
import * as Styled from './M045.styles'

/**
 * - M045 Product Finder
 * - It is a functional CMS component allowing customers to find their product via a series of filters.
 */
const M045 = (props) => (
  <Styled.Container data-test='m045-container'>
    <ProductFinder data-test='m045' {...props} />
  </Styled.Container>
)

M045.propTypes = {
  /** Category ID that authors will select from the Taxonomy tree */
  categoryIds: PropTypes.shape({
    synaptica: PropTypes.number.isRequired,
    pim: PropTypes.number.isRequired
  }),
  /** Optional function to handle clicks  */
  onLinkClick: PropTypes.func,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      /** Name of step i.e. Size */
      name: PropTypes.string.isRequired,
      /** Required text for heading */
      heading: PropTypes.string.isRequired,
      /** Required body copy text */
      bodyCopy: PropTypes.string.isRequired,
      /** The type of filter that will be applied, for example "Brand", "Colour". Will be used for the main step label */
      filterType: PropTypes.string.isRequired,
      /** Required array of filters */
      filters: PropTypes.arrayOf(
        PropTypes.shape({
          /** This displays under the image, describes the filter */
          label: PropTypes.string,
          /** This will appear an all steps within the finder and the product could will update after each selection, reflecting the amount of products available to them */
          values: PropTypes.string.isRequired,
          /** Required image */
          mainImage: PropTypes.shape({
            /** Image URL */
            source: PropTypes.string.isRequired,
            /** Alt text for the image */
            altText: PropTypes.string.isRequired
          }).isRequired
        })
      )
    })
  )
}

M045.defaultProps = {
  categoryIds: null,
  onLinkClick: null,
  steps: []
}

export default M045
